import { ReactNode } from "react";

type Props = { children: ReactNode; className?: string };

export default function Container({ children, className = "" }: Props) {
  return (
    <div className="min-h-screen">
      <div className={`mx-auto w-full max-w-6xl px-4 py-10 sm:px-6 lg:px-8 ${className}`}>
        {children}
      </div>
    </div>
  );
}
